import ConfirmationArea from "./ConfirmationArea.js";
import BottomArea from "./BottomArea.js";
import {MessageCollection, Message} from "../Message.js";
import global from "../global.js";
import ToastArea from "./ToastArea.js";
import FlashMessageArea from "./FlashMessageArea.js";

const log = global.log.getLogger("f_mtac.ui.LogsArea");
log.setLevel(log.levels.WARN);

const LogsArea = function LogsArea() {
    const collection = new MessageCollection();

    let scrollToLastMessage = function () {
        let message_list_height = document.querySelector("#logs_area .message-list").scrollHeight;
        document.querySelector("#logs_area .message-list").scrollTo({left: 0, top: message_list_height, behavior: "smooth"});
    };

    $("body").on("click", "#command_logs_right button[data-method=scroll]", scrollToLastMessage);

    $("body").on("click.new_message_area.btn", "#new_message_area .btn", async (event) => {
        var channel = global.storage.selected_space.selected_channel;
        let type = $(event.currentTarget).data("method") === "send_flash" ? 1 : 0;
        let text = $("#new_message_area textarea").val();
        $("#new_message_area textarea").val("");
        if (text) {
            // "#§#" used in replacement for \n for multi-line to work in collaboration.
            await channel.message_create({text: text.replaceAll("\n", "#§#"), sender_name: global.configuration.user.name, type, ack: 1, sender_tx_time: Date.now() * 1000});
            scrollToLastMessage();
        }
    });

    $("body").on("click", "#logs_area .message", (event) => {
        let message = global.datastorage.get($(event.currentTarget)[0], "dataMessage");
        if (message.ack) {
            return;
        }
        message.ack = true;
        global.storage.selected_space.selected_channel.message_update({local_id: message.id, ack: 1});
    });
    collection.publish("#logs_area");

    this.message_update = function (message, modifications) {
        collection.update(message, modifications);
    };
    this.message_insert = function (message) {
        collection.insert(message);
        // let message_list_height = document.querySelector("#logs_area .message-list").scrollHeight;
        // document.querySelector("#logs_area .message-list").scrollTo(0, message_list_height);
    };
    this.message_remove = function (message) {
        collection.remove(message);
    };
    this.message_load = async function (space) {
        let messages = await space.selected_channel.message_retrieve({});
        BottomArea.switcher_left.hide_marker("logs");
        messages.each((message) => {
            collection.insert(message);
            if (message.ack !== 1) {
                BottomArea.switcher_left.show_marker("logs");
            }
        });
    };
    this.message_unload = function (space) {
        if (space === null) {
            return;
        }
        space.selected_channel.message_retrieve({}).each((message) => {
            this.message_remove(message);
        });
        BottomArea.switcher_left.hide_marker("logs");
    };

    this.message_delete_all = async function () {
        await global.storage.selected_space.selected_channel.message_delete_all({});
    };

    this.messages_export_csv = async () => {
        let str = "";
        // entete fichier (noms colonnes)
        str = global.internationalization.text("logtab.Columns-date-text") + " \n";

        $("#logs_area .message").each((_, e) => {
            let message = global.datastorage.get($(e)[0], "dataMessage");
            let array = Message.getExportData(message);
            var line = "";
            for (var index in array) {
                if (line != "") {
                    line += ",";
                }
                line += array[index];
            }
            str += line + "\r\n";
        });
        let filename = "export" + Message.getExportDate() + ".csv";
        $("<a/>")
            .attr({
                id: "download-csv",
                href: "data:text/plain;charset=utf-8,%EF%BB%BF" + encodeURIComponent(str), //encode in UTF-8 BOM pour caracteres speciaux
                download: filename
            })[0]
            .click();

        ToastArea.interact("success", global.internationalization.text("logtab.Successful-export"));
    };

    this.ack_all = function () {
        $("#logs_area .message").each((_, e) => {
            let message = global.datastorage.get($(e)[0], "dataMessage");
            if (message.ack) {
                return;
            }
            message.ack = true;
            global.storage.selected_space.selected_channel.message_update({local_id: message.id, ack: 1});
        });
    };

    let update_marker = async () => {
        if (global.storage.selected_space === null) {
            // exception lors d'un rattachement à un partage ???
            return;
        }
        BottomArea.switcher_left.hide_marker("logs");
        let messages = await global.storage.selected_space.selected_channel.message_retrieve({});
        messages.each((message) => {
            if (message.ack !== 1) {
                BottomArea.switcher_left.show_marker("logs");
            }
        });
    };
    let message_on_creating = async () => {
        await update_marker();
    };
    let message_on_updating = async () => {
        await update_marker();
    };
    let message_on_deleting = async () => {
        await update_marker();
    };

    this.enable_all_features = function () {
        $("#new_message_area").css("display", "flex");
        $("#logs_actions button[data-tool-name=log-delete]").removeAttr("disabled");
        $("#logs_actions button[data-tool-name=export]").removeAttr("disabled");
    };
    this.disable_special_features = function () {
        $("#logs_actions button[data-tool-name=log-delete]").attr("disabled", true);
        $("#logs_actions button[data-tool-name=export]").attr("disabled", true);
    };
    this.disable_write_features = function () {
        $("#new_message_area").hide();
    };

    global.event_bus.subscribe("storage.shared", () => {
        this.enable_all_features();
        if (!(global.configuration.profiles[global.configuration.user.level].rights & global.configuration.rights.PROFILE_RIGHTS_SPECIAL)) {
            // User without special rights (observer + standard)
            this.disable_special_features();
        }
        if (!(global.configuration.profiles[global.configuration.user.level].rights & global.configuration.rights.PROFILE_RIGHTS_WRITE)) {
            // User without write rights (observer)
            this.disable_write_features();
        }
    });
    global.event_bus.subscribe("storage.unshared", () => {
        this.enable_all_features();
    });

    global.event_bus.subscribe("storage.space.changed", ({old_space, new_space}) => {
        if (old_space !== null) {
            this.message_unload(old_space);
        }
        if (new_space !== null) {
            this.message_load(new_space);
        }
    });

    global.event_bus.subscribe("user.level.changed", () => {
        if (!global.storage.shared()) {
            return;
        }
        this.enable_all_features();
        if (!(global.configuration.profiles[global.configuration.user.level].rights & global.configuration.rights.PROFILE_RIGHTS_SPECIAL)) {
            // User without special rights (observer + standard)
            this.disable_special_features();
        }
        if (!(global.configuration.profiles[global.configuration.user.level].rights & global.configuration.rights.PROFILE_RIGHTS_WRITE)) {
            // User without write rights (observer)
            this.disable_write_features();
        }
    });

    global.event_bus.subscribe("storage.channel.message.created", message_on_creating);
    global.event_bus.subscribe("storage.channel.message.updated", message_on_updating);
    global.event_bus.subscribe("storage.channel.message.deleted", message_on_deleting);

    const message_create_handler = (message) => {
        this.message_insert(message);
        if (message.type === 1 && BottomArea.switcher_left.mode === "tactics") {
            return FlashMessageArea.interact(message);
        }
    };

    const message_update_handler = (message, modifications) => {
        this.message_update(message, modifications);
    };

    const message_delete_handler = (message) => {
        this.message_remove(message);
    };

    const space_change_handler = async ({old_space, new_space}) => {
        if (old_space !== null) {
            old_space.selected_channel.message_off("creating", message_create_handler);
            old_space.selected_channel.message_off("updating", message_update_handler);
            old_space.selected_channel.message_off("deleting", message_delete_handler);
        }
        if (new_space !== null) {
            new_space.selected_channel.message_on("creating", message_create_handler);
            new_space.selected_channel.message_on("updating", message_update_handler);
            new_space.selected_channel.message_on("deleting", message_delete_handler);
        }
    };

    window.addEventListener("f_mtac.init", () => {
        global.tools.register({
            position: "#logs_actions",
            name: "ack-all",
            icon: "logs_ack f_mtac-icon-xlg",
            handler: async () => {
                this.ack_all();
            }
        });
        global.tools.register({
            position: "#logs_actions",
            name: "log-delete",
            icon: "logs_delete f_mtac-icon-xlg",
            handler: async () => {
                let confirmation = await ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("logtab.Delete-all-log-tab-logs")
                });
                if (!confirmation) {
                    return;
                }
                this.message_delete_all();
            }
        });
        global.tools.register({
            position: "#logs_actions",
            name: "export",
            icon: "export f_mtac-icon-xlg",
            handler: async () => {
                this.messages_export_csv();
            }
        });
    });

    // init fait apres le change_space => subscribe en dehors de l'init
    global.event_bus.subscribe("storage.space.changed", space_change_handler);
};

export default new LogsArea();
